<script>
export default {
  data () {
    return {
      showFloat: false
    }
  },
  // mounted () {
  //   this.showFloat = localStorage.getItem('floatShow')? false: true
  // },
  // methods: {
  //   closeFloat () {
  //     localStorage.setItem('floatShow', 'false')
  //     this.showFloat = false
  //   }
  // }
}
</script>
<template>
  <div class="float-blk" v-show="showFloat">
    <p class="float-text" >
            We use cookies to personalise content and ads, to provide social media features and to analvse our traffic. We also share information about vour use of our site with our social media, advertising and analytics partners who may combine it with other information that you've provided to them or that they've collected from your use of their services. Check 
            <router-link to="/privacy">Privacy policy</router-link>
        </p>
        <div class="btn" @click="closeFloat">
            I understand
        </div>
  </div>
</template>
<style lang='scss'>
@import '@/styles/public.scss';

.float-blk{
    box-sizing: border-box;
    width: 100%;
    height: 132px;
    background-color: #111111;
    padding: 30px 120px;
    position: fixed;
    bottom: 0;
    left: 0;
    z-index: 100;
    display: flex;
    .float-text{
      font-size: 15px;
      line-height: 24px;
      color: #FFFFFF;
      flex: 1;
  }
  .btn{
      width: 192px;
      height: 44px;
      line-height: 44px;
      border-radius: 100px;
      background: #FFF;
      font-size: 16px;
      text-align: center;
      color: #1C58F5;
      font-weight: bold;
      padding: 0px 40px;
      margin-left: 19px;
      cursor: pointer;

  }a {
      color: #1C58F5;
  }
}
</style>